module.exports = __webpack_public_path__ + "static/drone-0d375ea6c52a482c92dea8dac3159d20.jpg";